import { useMemo } from 'react';
import { getCoachPremiumPage } from 'constants/pages';
import { UserContentTiersEnum } from 'types/generated/client';
import Link from 'components/Link';
import Pill from 'components/Pill';
import { getSkillLabel } from 'components/SkillAnalysis/utils';
import classNames from 'styles/utils/classNames';
import { PremiumContentCardProps } from './props';
import { formatCreationWithIntl } from './utils';

const PremiumContentCard: React.FC<PremiumContentCardProps> = ({
  responsive = true,
  vertical = true,
  entity,
  coachId,
}) => {
  const timeAgo = useMemo(
    () => (entity.createdAt ? formatCreationWithIntl(entity.createdAt) : ''),
    [entity.createdAt],
  );

  const url = `${getCoachPremiumPage(coachId)}/${entity.id}`;

  return (
    <Link href={url}>
      <div
        className={classNames(
          'flex',
          vertical && 'flex-col',
          'flex-row gap-3',
          responsive && 'max-sm:flex-row max-sm:gap-3',
        )}
      >
        <div
          className={classNames(
            'relative h-[7rem] shrink-0 overflow-hidden rounded-lg ',
            responsive && 'max-sm:w-40',
            !vertical && 'w-40',
          )}
        >
          {entity.tier === UserContentTiersEnum.Premium && (
            <Pill className="absolute right-1 top-2" text="Premium" size="sm" type="brand" />
          )}
          <video
            className="h-full w-full object-cover"
            src={`${entity.url}#t=0.001`}
            muted
            playsInline
            disablePictureInPicture
            controls={false}
          />
          {/* <div className="absolute bottom-2 right-2 rounded-md bg-[#00000090] px-1">
          <span className="typography-product-button-label-small text-color-text-lightmode-invert dark:text-color-text-darkmode-invert">
            30:30
          </span>
        </div> */}
        </div>
        <div className="flex flex-col gap-2 py-2">
          <div className="flex flex-wrap gap-2">
            {entity.userContentFilesSkills.map((skill, index) => (
              <Pill
                text={getSkillLabel(
                  skill.userContentSkills.customSkill || skill.userContentSkills.skill || '',
                )}
                size="sm"
                key={index}
              />
            ))}
          </div>
          <h4 className="typography-product-card-title-desktop">{entity.title}</h4>
          <span className="typography-product-chips-filters text-color-text-lightmode-tertiary dark:text-color-text-darkmode-tertiary">
            {timeAgo}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default PremiumContentCard;
